import type { State } from '../index'
import { useContext } from 'react'
import { Button, Form, Input, message } from 'antd'
import { ModalContext } from 'src/components'
import { layoutStore, mainStore } from 'enasops/stores'
import { $api } from 'src/plugins'

type Props = {
  record?: {
    ID?: string,
    CODE?: string,
    NAME?: string
  }
}

const Create = (props: Props) => {
  const modal = useContext(ModalContext)

  const state: State = layoutStore.slotData.state

  const [form] = Form.useForm()

  const handleOK = (values: any) => {
    $api['op140/update']({
      ...values,
      ORG_ID: mainStore.headers.OrgId,
      INDUSTRY_TYPE: 2,
    }).then(res => {
      if (res) {
        state.getIndustry()
        handleCancel()
        message.success('保存成功')
      }
    })
  }

  const handleCancel = () => {
    modal.close()
  }

  return (
    <Form
      form={form}
      initialValues={props.record}
      onFinish={handleOK}
      layout='horizontal'
      labelCol={{ span: 9 }}
      wrapperCol={{ span: 15 }}
    >
      <Form.Item hidden name='ID'><Input /></Form.Item>
      <Form.Item name='CODE' label='领域行业编码' rules={[{ required: true }]}>
        <Input placeholder='请输入领域行业编码' />
      </Form.Item>
      <Form.Item name='NAME' label='领域行业名称' rules={[{ required: true }]}>
        <Input placeholder='请输入领域行业名称' />
      </Form.Item>
      <Form.Item label=' ' colon={false}>
        <Button onClick={handleCancel} className='mg-r8'>取消</Button>
        <Button type='primary' htmlType='submit'>确认</Button>
      </Form.Item>
    </Form>
  )
}

export default Create